<template>
  <div
    :class="isHebrew ? 'text-right' : 'text-left'"
    style="font-size: 14px;
    letter-spacing: 0.045em;
    line-height: 18px;"
  >
    <span v-if="visible === false">
      <div :dir="isHebrew ? 'rtl' : 'ltr'">
      <span style="white-space: pre-wrap;"
            v-html="shortText"
        ></span>
      <span v-if="isTruncated" 
            style="white-space: pre-wrap;">...</span>
      
      <span v-if="isTruncated">
        <br />
        <b-link
          class="text-underline set_to_the_right_color"
          href
          @click.prevent="visible = !visible"
          :class="visible ? null : 'collapsed'"
          :aria-expanded="visible ? 'true' : 'false'"
          :aria-controls="'collapse-' + uniqueId"
          >{{ t('showMore') }}</b-link
        >
      </span>
      </div>
    </span>
    <div>
      <!-- Element to collapse -->
      <b-collapse :id="'collapse-' + uniqueId" v-model="visible">
        <div :dir="isHebrew ? 'rtl' : 'ltr'">
        <span style="white-space: pre-wrap;"
              v-html="text"
        ></span>
        <br />
        <b-link 
          href @click.prevent="visible = !visible"
          class="set_to_the_right_color"
          >{{ t('showLess') }}</b-link>
        </div>
      </b-collapse>
    </div>
  </div>
</template>
<script>
import { translationMixin } from "@/mixins/translationMixin";

export default {
  mixins: [translationMixin],
  props: {
    text: {
      type: String,
      required: true
    },
    uniqueId: {
      type: [String, Number],
      required: false,
      default: null
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    shortText() {
      return this.text.length > 150 ? this.text.slice(0, 150) : this.text;
    },
    isTruncated() {
      return this.text.length > 150;
    },
  },
};
</script>

<style scoped>

.set_to_the_right_color{
  color: #007bff!important;
}
</style>